module.exports = __webpack_public_path__ + "static/media/mainLogo1.cd0e2f98.png";